import { makeStyles } from '@cuda-networks/bds-core'

export default makeStyles({
  root: {
    margin: 20
  },
  progress: {
    marginTop: 0
  }
})
